import { reportErrorToDataDog } from '../../../utils/datadog';
import { getRedirectUrl } from '../services/redirectService';
import { isAcademyDomain } from '../../../utils/getAcademyDomain';

async function getAcademyTokenWithoutPrompt(oktaAuth) {
  try {
    const { tokens } = await oktaAuth.token.getWithoutPrompt();
    oktaAuth.tokenManager.setTokens(tokens);
    return tokens.accessToken;
  } catch (silentAuthError) {
    const errorMsg = 'Silent token refresh failed';
    console.error(errorMsg, silentAuthError);
    reportErrorToDataDog(errorMsg, {
      errorLocation: 'sessionUtils.getAcademyTokenWithoutPrompt',
      sessionStatus: 'ACTIVE',
      error: silentAuthError?.message,
    });
    return null;
  }
}

export async function redirectIfActiveSession(oktaAuth, locationState) {
  const comingFromLogout = locationState?.fromLogout;

  if (comingFromLogout) {
    return;
  }

  const searchParams = new URLSearchParams(window.location.search);
  const isZendeskSso = !!searchParams.get('zendeskSso');
  const isKongSource = searchParams.get('source') === 'kong';

  if (isZendeskSso || isKongSource) {
    return;
  }

  try {
    const session = await oktaAuth.session.get();
    const hasActiveSession = session.status === 'ACTIVE';

    if (!hasActiveSession) {
      return;
    }

    const accessToken = await oktaAuth.tokenManager.get('accessToken');

    if (!accessToken) {
      if (isAcademyDomain) {
        const academyAccessToken = await getAcademyTokenWithoutPrompt(oktaAuth);
        if (!academyAccessToken) {
          return;
        }
      } else {
        const errorMsg = 'Active session found but no access token available';
        console.error(errorMsg);
        reportErrorToDataDog(errorMsg, {
          errorLocation: 'sessionUtils.redirectIfActiveSession',
          sessionStatus: 'ACTIVE',
        });
        return;
      }
    }

    const redirectUrl = getRedirectUrl();
    window.location.replace(redirectUrl);
  } catch (error) {
    const message = typeof error === 'string' ? error : error?.message;
    console.error('Session check:', message);
  }
}
